import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import SelectDate from "./SelectDate"
import { FC } from "react"
import { DatePickerProps } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

type SelectDateFromProps = {
  size?: "small" | "default",
  layout?: "default" | "hero",
  heroSegment?: boolean,
  compact?: boolean,
  hideItineraryToggle?: boolean,
  indexInputFlight: number,
  onlyContent?: boolean
}

const SelectDateFrom: FC<SelectDateFromProps> = ({
  size = 'default',
  layout = 'default',
  heroSegment,
  compact,
  hideItineraryToggle,
  onlyContent,
  indexInputFlight,
}) => {
  const dateFrom = useAppSelector(state => state.flight.inputFlights[indexInputFlight].dateFrom)
  const { t } = useTranslation()
  return (
    <SelectDate
      size={size}
      layout={layout}
      heroSegment={heroSegment}
      compact={compact}
      hideItineraryToggle={hideItineraryToggle}
      value={dateFrom}
      indexInputFlight={indexInputFlight}
      label={t("flight.departure_date")}
      onlyContent={onlyContent}
    />
  )
}

SelectDateFrom.displayName = 'SelectDateFrom'

export default SelectDateFrom